module.exports = __webpack_public_path__ + "img/bb.881a7e79.jpg";